import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const emailConfirmationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/email_confirmation',
  validateSearch: z.object({
    confirmation_token: z.preprocess((v) => (v === undefined ? undefined : `${v}`), z.string()),
  }),
}).lazy(() => import('pages/shared/EmailConfirmation/EmailConfirmationPage').then((d) => d.Route));
